import { render, staticRenderFns } from "./add.modal.vue?vue&type=template&id=192dc394&scoped=true"
import script from "./add.modal.vue?vue&type=script&lang=js"
export * from "./add.modal.vue?vue&type=script&lang=js"
import style0 from "./add.modal.vue?vue&type=style&index=0&id=192dc394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192dc394",
  null
  
)

export default component.exports